var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_37557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 8.47994V19.9999C23.9999 20.2652 23.8946 20.5195 23.707 20.707C23.5195 20.8946 23.2651 20.9999 22.9999 20.9999C22.7347 20.9999 22.4803 20.8946 22.2928 20.707C22.1053 20.5195 21.9999 20.2652 21.9999 19.9999V11.7519L14.5999 15.2879C13.8197 15.7485 12.9289 15.9884 12.0229 15.9819C11.0728 15.9834 10.1399 15.7281 9.32291 15.2429L1.94291 11.7299C1.36279 11.418 0.876721 10.9565 0.535132 10.3933C0.193543 9.83012 0.00888329 9.18579 0.000312565 8.52717C-0.00825816 7.86855 0.159573 7.21964 0.486391 6.64776C0.813209 6.07588 1.28711 5.60188 1.85891 5.27494C1.88591 5.25894 1.91491 5.24394 1.94291 5.22994L9.39991 1.67194C10.205 1.2096 11.1187 0.970064 12.047 0.977973C12.9754 0.985882 13.8848 1.24095 14.6819 1.71694L22.0569 5.22994C22.6388 5.55192 23.1252 6.02223 23.4664 6.59306C23.8077 7.1639 23.9918 7.81491 23.9999 8.47994ZM12.0219 17.9799C10.7425 17.9828 9.48504 17.6475 8.37691 17.0079L3.99991 14.9189V17.6189C4.00051 18.6865 4.34228 19.7258 4.97534 20.5854C5.6084 21.445 6.49962 22.0797 7.51891 22.3969C8.97524 22.8151 10.4849 23.0182 11.9999 22.9999C13.5152 23.0169 15.0248 22.8124 16.4809 22.3929C17.5002 22.0757 18.3914 21.441 19.0245 20.5814C19.6575 19.7218 19.9993 18.6825 19.9999 17.6149V14.9239L15.5409 17.0539C14.4706 17.6689 13.2563 17.9891 12.0219 17.9819V17.9799Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_37557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCole);
export default __webpack_public_path__ + "static/media/COLE.cba5fc8a867e22c8db022b9dc6a84d5a.svg";
export { ForwardRef as ReactComponent };